<router-outlet></router-outlet>

<!-- Add more app icons as needed -->
